<section class="course-intro">
    <h2 class="text-blue-dark font-headings text-6xl md:text-7xl lg:text-8xl uppercase mb-2">{{cmsDataService.configuration.globalStrings.coreValuesTitle}}</h2>
    <p class="text-2xl leading-8 lg:w-2/3 xl:w-1/2" [innerHTML]="cmsDataService.configuration.globalStrings.coreValuesText | filterKeyPhrases"></p>
</section>
<section class="course-grid" [@blockAnimation]>
    <app-course *ngFor="let course of cmsDataService.configuration.courses" [course]="course"></app-course>
</section>
<app-sponsor breakpoint="lg" theme="dark"></app-sponsor>
